import fetch from './index'

export function getCaptcha(params) {
  return fetch.post('sms/captcha', params)
}